/**
 * @jest-environment jsdom
 */
import { useEffect } from 'react'
import { subscribeAndProcess } from '../../../../common/pageBus'

export const useInjectFragment = ({ eventName, elementId, containerId }) => {
  useEffect(() => {
    subscribeAndProcess('product-info', eventName, () => {
      document.getElementById(containerId).appendChild(document.getElementById(elementId))
    })
  }, [containerId, elementId, eventName])
}
